module.exports = __webpack_public_path__ + "img/sf.299264bf.jpg";